import React from 'react';
import ReactTooltip from 'react-tooltip';

const JSTooltip = ReactTooltip as any;

type TooltipProps = {
    tooltipBody: JSX.Element;
}
const iconStyle = {
    marginLeft: "8px"
}

function Tooltip({ tooltipBody }: TooltipProps) {

    return (
        <>
            <i data-tip className="fa fa-info-circle" style={iconStyle} data-for="tool-tip" />
            <JSTooltip id="tool-tip" place="right" backgroundColor='#0087a2' effect="solid">
                {tooltipBody}
            </JSTooltip>
        </>
    );
}
export default Tooltip;
